export const client = {
  api: null,
  path: {}
};
